/* dl-cart-print.js — Světelný plán: typesets the cart as a compact quote sheet.
   v3 (2026-08-11).
   1. QR size comes from the code's own module count (dense share links get a bigger tile). It sits
      in the masthead and once more in the summary row — nowhere else.
   2. Photo size is FIXED by CSS (--thumb). v2 chose it by searching a size/gap grid and then grew a
      shared scale by bisection; the fit test read `return spill || stack <= box - SAFE`, so any sheet
      holding a block taller than a page reported a fit unconditionally — and growing the photo is
      exactly what made blocks over-tall. The guard switched itself off the moment it began to bind
      and the scale ran to best.size + 63 (live: 121mm photos on a 186mm sheet, 4 items over 3 pages).
      Rows are now short enough that ordinary CSS pagination fills the page; .cline carries
      break-inside:avoid so a row is never split, and .psub break-after:avoid keeps a room title with
      its room. No measuring, no page-break class, no pinning of the summary.
   3. Prices are optional: DLK_printPrices(false) prints the plan without line prices, room sums or
      the total. The choice is remembered in localStorage. It ONLY stores the choice — v2 called
      build() here, which injected the whole print masthead + QR into the LIVE cart page, where the
      print stylesheet does not apply, so the QR rendered full-bleed and the cart was unusable until
      reload. Injection now happens on print only.
   4. Masthead on the first sheet only; the summary (items · rooms · total + QR) follows the last room.
   Everything injected here is removed on afterprint and on leaving print media. Pairs with
   assets/dl-cart-print.css. Needs window.DLK_shareLink() from dl-cart.js; QR needs dl-qr.js
   (global `qrcode`). Called by dl-cart.js: `[data-print]` -> DLK_printSheets() then window.print(). */
(function(){
var ADDR='Sázavská 32 a 30 · Vinohrady · Po–Čt 10–18, Pá 10–16';
var CONTACT='info@artemide.cz · +420 602 360 300';
var CAP='Košík k úpravě';  /* the link restores rooms, selling plans, quantities and variants */
var MM=96/25.4;
var PAGE_H=273*MM;              /* A4 297mm − @page margins 12+12 */
var QR_MOD=0.4,QR_MIN=24,QR_MAX=34; /* mm per module (0.4 ≈ phone-camera floor), and the window */
function prices(){try{return localStorage.getItem('dlk-print-prices')!=='0';}catch(e){return true;}}
function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
function plural(n){return n+(n===1?' položka':(n<5?' položky':' položek'));}
function rplural(n){return n+(n===1?' místnost':(n<5?' místnosti':' místností'));}
function units(scope){var q=0;[].forEach.call(scope.querySelectorAll('.cline .qty span'),function(s){q+=parseInt(s.textContent,10)||0;});return q;}
/* QR — a share link carries rooms, selling plans, quantities and variant ids, so the code is dense.
   Size it from its own module count instead of a fixed guess. */
function qr(){
 var f=window.DLK_shareLink;
 if(typeof qrcode==='undefined'||typeof f!=='function')return null;
 try{
  var q=qrcode(0,'L');q.addData(f());q.make();
  var mods=(typeof q.getModuleCount==='function'?q.getModuleCount():57);
  return {svg:q.createSvgTag({cellSize:2,margin:2,scalable:true}),
          mm:Math.min(QR_MAX,Math.max(QR_MIN,Math.round(mods*QR_MOD)))};
 }catch(e){return null;}
}
function qrHTML(code){
 return code?'<span class="qrw"><span class="cap">'+CAP+'</span><span class="code">'+code.svg+'</span></span>':'';
}
function headHTML(date,code){
 return '<div class="phd" aria-hidden="true"><span class="id">'+
  '<span class="top"><span class="logo">design—light</span><span class="dt">'+date+'</span></span>'+
  '<span class="msg"><span>'+ADDR+'</span><span>'+CONTACT+'</span></span></span>'+qrHTML(code)+'</div>';
}
function titleHTML(name,cls,meta){
 return '<div class="psub" aria-hidden="true"><span class="rm'+cls+'">'+esc(name)+'</span>'+
  '<span class="cn">'+esc(meta)+'</span><span class="sp"></span></div>';
}
/* removes every trace of a build — safe to call when nothing was injected */
function clear(root){
 root=root||document.getElementById('dlk');
 if(!root)return 0;
 [].forEach.call(root.querySelectorAll('.phd,.psub,.pfin'),function(n){n.parentNode.removeChild(n);});
 [].forEach.call(root.querySelectorAll('.pgbreak'),function(n){n.classList.remove('pgbreak');});
 [].forEach.call(root.querySelectorAll('.rsec,.flat'),function(n){n.style.removeProperty('--thumb');n.style.removeProperty('--rowpad');});
 var s=root.querySelector('.csum');if(s)s.style.marginTop='';
 root.style.removeProperty('--qrw');
 return 0;
}
function printLink(){
 return [].slice.call(document.querySelectorAll('link[rel="stylesheet"]')).filter(function(l){
  return l.href&&l.href.indexOf('dl-cart-print')>-1;})[0]||null;
}
/* run fn with the print stylesheet applied at A4 content width. Synchronous: nothing is painted
   between the two style changes, so this never flashes on screen. */
function inPrint(root,fn){
 var link=printLink(),media=link?link.media:null,w=root.style.width,pos=root.style.position,vis=root.style.visibility;
 if(link)link.media='all';
 root.style.position='static';root.style.width='186mm';root.style.visibility='visible';
 var out;
 try{out=fn();}finally{
  if(link)link.media=media;
  root.style.width=w;root.style.position=pos;root.style.visibility=vis;
 }
 return out;
}
function build(root){
 root=root||document.getElementById('dlk');
 if(!root)return 0;
 clear(root);
 var blocks=[].slice.call(root.querySelectorAll('.rsec,.flat'));
 var sum=root.querySelector('.csum');
 if(!blocks.length&&!sum)return 0;
 var date=new Date().toLocaleDateString('cs-CZ'),code=qr();
 var showPrices=prices();
 root.classList.toggle('noprices',!showPrices);
 root.style.setProperty('--qrw',(code?code.mm:0)+'mm');
 /* Only rooms that actually hold items: an empty room is display:none in print, so a title — or
    worse, the masthead — parked inside one would silently vanish from the sheet. v2 used
    rooms[0] unconditionally; a cart whose first room is empty printed with no masthead at all. */
 var filled=blocks.filter(function(b){return b.querySelector('.cline');});
 /* chapter opener per room; .rhead is hidden by the print stylesheet in its place */
 filled.forEach(function(el){
  var rn=el.querySelector('.rnm'),rs=el.querySelector('.rsum');
  el.insertAdjacentHTML('afterbegin',titleHTML(rn?rn.textContent:'Košík',
   (rn&&!el.getAttribute('data-drop'))?' un':'',
   plural(units(el))+((rs&&showPrices)?' · '+rs.textContent.trim():'')));
 });
 if(filled[0])filled[0].insertAdjacentHTML('afterbegin',headHTML(date,code));
 if(sum){
  var tot=root.querySelector(".csum .rw.tot .v"),rc=filled.length;
  sum.insertAdjacentHTML('beforeend','<div class="pfin" aria-hidden="true"><span class="k">Souhrn<br>'+
   esc(plural(units(root))+' · '+rplural(rc))+'</span><span class="sp"></span>'+
   '<span class="tot"><b>'+esc(tot?tot.textContent.trim():'')+'</b><span class="vat">vč. DPH</span></span>'+
   qrHTML(code)+'</div>');
 }
 /* Report the sheet count the browser will produce. Purely advisory — nothing in the layout depends
    on it, which is the point: v2 fed this measurement back into the photo scale. While print media
    is already applied (beforeprint, the print media query) measure directly; otherwise borrow the
    print stylesheet for one synchronous read. */
 var mq=window.matchMedia&&window.matchMedia('print');
 var h=(mq&&mq.matches)?root.getBoundingClientRect().height
                       :inPrint(root,function(){return root.getBoundingClientRect().height;});
 return Math.max(1,Math.ceil(h/PAGE_H));
}
window.DLK_printPrices=function(on){
 try{localStorage.setItem('dlk-print-prices',on?'1':'0');}catch(e){}
 var r=document.getElementById('dlk');
 if(r){clear(r);r.classList.toggle('noprices',!on);}
 return 0;   /* deliberately does NOT build: build() injects into the live page, see header note 3 */
};
window.DLK_printPricesOn=prices;
window.DLK_printSheets=build;
window.DLK_printSheetsClear=clear;
window.addEventListener('beforeprint',function(){build();});
window.addEventListener('afterprint',function(){clear();});
/* Safari fires before/afterprint late or not at all in some versions; the print media query is the
   reliable signal there. Both paths are idempotent — build() clears before it injects. */
if(window.matchMedia){
 var mq=window.matchMedia('print');
 var onmq=function(m){if(m.matches)build();else clear();};
 if(mq.addEventListener)mq.addEventListener('change',onmq);
 else if(mq.addListener)mq.addListener(onmq);
}
})();
